// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Gcka","productName":"Table_productName__3QX5D"};